import { contains, find, propEq } from 'ramda';
import { FilterName } from '../constants/FilterName';
import {
  IExtendedFilter,
  IFilterItem,
} from '../containers/FilesManager/ExtendedItemsFilters/ExtendedItemsFilters.types';
import { containsTag } from './media-manager-sdk/items';
import { MediaManagerSDKPublicMediaFolder } from './hoc/withPublicMedia/withPublicMedia.types';
import { MediaType } from '../constants/MediaType';
import { WixMediaRoot } from '../constants/WixMediaRoot';

export const getActiveItemFilter = (itemsFilters: IExtendedFilter[], name: FilterName): IFilterItem => {
  if (!itemsFilters) {
    return null;
  }

  const itemsFilter = find<IExtendedFilter>(propEq('name', name), itemsFilters);

  if (!itemsFilter) {
    return null;
  }

  const { activeItemId, menuItems } = itemsFilter;

  return find<IFilterItem>(propEq('id', activeItemId), menuItems) || null;
};

export const isNewCategory = containsTag('new');

export const isTransparentIconsCategory = (category: string) =>
  contains(category, [WixMediaRoot.SocialIcons, WixMediaRoot.SocialIconsComponent]);

export const isCategoryOfNonVisualMediaType = (category?: MediaManagerSDKPublicMediaFolder) =>
  !!category?.mediaType &&
  category.mediaType !== MediaType.Video &&
  category.mediaType !== MediaType.Picture &&
  category.mediaType !== MediaType.VectorArt;
